/**
 * when the user changes its settings
 * @type {handler}
 */
define('components/handlers/mysettings',[
    'jquery',
    '../handlers/analytics'
],function(
    jQuery,
    analytics
){

    $.extend(companyInfo.handlers,{

        /**
         * Check if the newsletter settings are changed.
         * If so, send info to GTM
         */
        "mysettings-newsletter": function( e ){
            var alerts = $("input[name='prefs.alerts']:checked").val();
            var alerts_old = $("#alerts_old").val();

            //check if the alerts setting has changed
            if(alerts !== alerts_old){
                analytics (["user settings","change newsletter subscription", alerts]);
            }

            //newsletter
            var newsletter = $("input[name='prefs.noNewsletter']:checked").val();
            var newsletter_old = $("#noNewsletter_old").val();
            //check if the newsletter setting has changed
            if(newsletter !== newsletter_old){
                analytics (["user settings","change newsletter subscription", "newsletter"]);
            }
        }

    });

});

